// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-container{
    position: fixed;
    top: 0px;
    right: 0px;
    z-index: 10;
    width: 100vw;
    height: 100vh;
    background: rgba(233, 230, 230, 0.514);
    display: flex;
    align-items: center;
    justify-content: center;
}
.model-wapper{
    background: #ffffff;
    border-radius: 4px;
    padding: 16px;
}`, "",{"version":3,"sources":["webpack://./client/components/styles/modal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB","sourcesContent":[".modal-container{\n    position: fixed;\n    top: 0px;\n    right: 0px;\n    z-index: 10;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(233, 230, 230, 0.514);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.model-wapper{\n    background: #ffffff;\n    border-radius: 4px;\n    padding: 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
